import React from "react";
import { getRuntimeConfig } from "./getRuntimeConfig";

const ConfigContext = React.createContext(null);

export function ConfigProvider({ children }) {
  const config = React.useMemo(() => getRuntimeConfig(), []);
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  const ctx = React.useContext(ConfigContext);
  if (!ctx) throw new Error("useConfig must be used inside ConfigProvider");
  return ctx;
}
